import { CATEGORY_BY_ID } from '../categories';
import type { Registration } from '../registry';

const v = CATEGORY_BY_ID.variables.colour;
const x = CATEGORY_BY_ID.math.colour;
const tx = CATEGORY_BY_ID.text.colour;

export const variablesRegistration: Registration = {
  definitions: [
    {
      type: 'esp32_variable_declare',
      message0: 'declare global %1 %2 = %3',
      args0: [
        {
          type: 'field_dropdown',
          name: 'TYPE',
          options: [
            ['int', 'int'],
            ['float', 'float'],
            ['bool', 'bool'],
            ['String', 'String'],
            ['volatile int', 'volatile int'],
            ['volatile bool', 'volatile bool'],
          ],
        },
        { type: 'field_input', name: 'NAME', text: 'counter' },
        { type: 'input_value', name: 'INITIAL' },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: v,
      tooltip: 'Declare a named global variable. Use volatile types for flags shared with interrupts.',
    },
    {
      type: 'esp32_global_read',
      message0: 'global %1',
      args0: [{ type: 'field_input', name: 'NAME', text: 'counter' }],
      output: null,
      colour: v,
      tooltip: 'Read a declared global variable.',
    },
    {
      type: 'esp32_global_write',
      message0: 'set global %1 to %2',
      args0: [
        { type: 'field_input', name: 'NAME', text: 'counter' },
        { type: 'input_value', name: 'VALUE' },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: v,
      tooltip: 'Write to a declared global variable.',
    },
    {
      type: 'esp32_map',
      message0: 'map %1 from %2..%3 to %4..%5',
      args0: [
        { type: 'input_value', name: 'VALUE', check: 'Number' },
        { type: 'input_value', name: 'IN_MIN', check: 'Number' },
        { type: 'input_value', name: 'IN_MAX', check: 'Number' },
        { type: 'input_value', name: 'OUT_MIN', check: 'Number' },
        { type: 'input_value', name: 'OUT_MAX', check: 'Number' },
      ],
      output: 'Number',
      inputsInline: true,
      colour: x,
      tooltip: 'Arduino map(): re-range a number from one range to another.',
    },
    {
      type: 'esp32_constrain',
      message0: 'constrain %1 between %2 and %3',
      args0: [
        { type: 'input_value', name: 'VALUE', check: 'Number' },
        { type: 'input_value', name: 'LOW', check: 'Number' },
        { type: 'input_value', name: 'HIGH', check: 'Number' },
      ],
      output: 'Number',
      inputsInline: true,
      colour: x,
      tooltip: 'Arduino constrain(): clamp a number into a range.',
    },
    {
      type: 'esp32_text_join',
      message0: 'join %1 %2',
      args0: [
        { type: 'input_value', name: 'A' },
        { type: 'input_value', name: 'B' },
      ],
      output: 'String',
      inputsInline: true,
      colour: tx,
      tooltip: 'Convert both values to text and concatenate them.',
    },
  ],
  metas: [
    {
      type: 'esp32_variable_declare',
      category: 'variables',
      label: 'Declare global',
      description: 'Declare a global variable with an explicit C++ type (int, float, bool, String, volatile int, volatile bool).',
      fields: { TYPE: { kind: 'dropdown', options: ['int', 'float', 'bool', 'String', 'volatile int', 'volatile bool'] }, NAME: { kind: 'text' }, INITIAL: { kind: 'value', types: 'any' } },
    },
    {
      type: 'esp32_global_read',
      category: 'variables',
      label: 'Global read',
      description: 'Value: read a declared global by name.',
      fields: { NAME: { kind: 'text' } },
    },
    {
      type: 'esp32_global_write',
      category: 'variables',
      label: 'Global write',
      description: 'Assign a value to a declared global by name.',
      fields: { NAME: { kind: 'text' }, VALUE: { kind: 'value', types: 'any' } },
    },
    {
      type: 'esp32_map',
      category: 'math',
      label: 'Map',
      description: 'Value: Arduino map(x, inMin, inMax, outMin, outMax).',
      fields: { VALUE: { kind: 'value', types: 'Number' }, IN_MIN: { kind: 'value', types: 'Number' }, IN_MAX: { kind: 'value', types: 'Number' }, OUT_MIN: { kind: 'value', types: 'Number' }, OUT_MAX: { kind: 'value', types: 'Number' } },
    },
    {
      type: 'esp32_constrain',
      category: 'math',
      label: 'Constrain',
      description: 'Value: Arduino constrain(x, low, high).',
      fields: { VALUE: { kind: 'value', types: 'Number' }, LOW: { kind: 'value', types: 'Number' }, HIGH: { kind: 'value', types: 'Number' } },
    },
    {
      type: 'esp32_text_join',
      category: 'text',
      label: 'Join text',
      description: 'Value: concatenation of two values converted to text.',
      fields: { A: { kind: 'value', types: 'any' }, B: { kind: 'value', types: 'any' } },
    },
  ],
};
